import { registerFeature } from "lib/features"
import { isEnabled } from "lib/@components/feature"
import { registerTab } from "lib/@components/tabs"
import { Lazy } from "lib/make-lazy"
import { appRoute } from "routes/app/home.runtime"
import { HeaderBarRight, ScheduleItemMainExtra } from "slot-definitions"
import { hasDemand } from "lib/authorization/has-demand"
import { FEATURE_FLAG_CODES_OF_PRACTICE } from "./feature-flag-codes-of-practice"
import { CopGroupDetailPage } from "./cop-group-detail-page"
import { CopResolutionDetailPage } from "./cop-resolution-detail-page"
import { CopPreviewSelector } from "./cop-preview-selector"
import { CopVariantBadge } from "./cop-variant-badge"

registerFeature({
    numericalId: 1005,
    id: FEATURE_FLAG_CODES_OF_PRACTICE,
    name: "Codes of Practice",
    description: "Manage Codes of Practice groups and scan schedules for compliance.",
    readyForBeta: false,
    readyForProduction: false,
    internalUseOnly: true,
})

registerTab({
    tab: "sfg20AdminTabs",
    id: "codesOfPractice",
    title: "Codes of Practice",
    demands: "admin",
    content: <Lazy importer={() => import("./cop-admin-page")} extract="CopAdminPage" priority={6} />,
    predicate: () => isEnabled(FEATURE_FLAG_CODES_OF_PRACTICE),
})

appRoute.register("cop-group/:groupId", <CopGroupDetailPage $lazy />)

appRoute.register("cop-resolution/:id", <CopResolutionDetailPage $lazy />)

HeaderBarRight.plug(
    <CopPreviewSelector
        $lazy
        priority={500}
        if={() => hasDemand("admin") && isEnabled(FEATURE_FLAG_CODES_OF_PRACTICE)}
    />
)

ScheduleItemMainExtra.plug(<CopVariantBadge $lazy if={isEnabled(FEATURE_FLAG_CODES_OF_PRACTICE)} />)
